export const PUBLISH_DESTINATION = {
    INTERACTY: 'INTERACTY',
    TEACHER_CONTENT: 'TEACHER_CONTENT',
}

export const PUBLISH_DESTINATION_LABELS = {
    [PUBLISH_DESTINATION.INTERACTY]: 'Interacty',
    [PUBLISH_DESTINATION.TEACHER_CONTENT]: 'Teacher Content',
}
